import { render, staticRenderFns } from "./auth-re-password-three.vue?vue&type=template&id=46f380cb&"
import script from "./auth-re-password-three.vue?vue&type=script&lang=js&"
export * from "./auth-re-password-three.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports